/* eslint-disable no-console */
import { announceMessage } from '../accessibility/status-messages';
import { clearAllSwatchbookData, getAllOfType } from '../swatchbook-utils';
import {
  dispatchSiteEvent,
  siteEventNames,
} from '../../events/site-events';
import { login, logout, addSwatches } from './account-api';
import { openAccountModal, closeAccountModal } from './account-modal';
import { addCreateAccountCallbacks, resetCreateAccountForm, setCreateAccountFocus } from './create-account';
import { updateAccountIconStatus } from './account-status-helpers';
import { validate } from '../../utils/form-validation-utils';

let initialLanuch = true;

const loginModalId = 'acct-login-modal';

const onLoginSubmit = (event, callbacks) => {
  event.preventDefault();
  const modalForm = document.querySelector('.acct-login-modal-form');
  const modalErrorMsg = modalForm.querySelector('.form-error-message');
  if (validate(modalForm)) {
    modalErrorMsg.classList.add('hide');
    let remember = false;
    if (document.querySelectorAll('#modalAcctRememberMe:checked').length === 1) {
      remember = true;
    }
    login(
      {
        username: document.getElementById('modalAcctUsername').value,
        password: document.getElementById('modalAcctPassword').value,
        rememberMe: remember,
      },
      {
        onSuccess: (data) => {
          // console.log(data);
          if (!data.success) {
            modalErrorMsg.classList.remove('hide');
            announceMessage(modalErrorMsg.innerHTML);
          } else {
            window.isAuthenticated = true;
            window.userId = data['user-id'];
            dispatchSiteEvent(siteEventNames.ON_LOGGED_IN);
            checkLoginStatus(() => { // eslint-disable-line no-use-before-define
              if (callbacks) {
                if (callbacks.onLoginSuccess) {
                  callbacks.onLoginSuccess();
                }
              }
            });
            const modal = document.querySelector(`#${loginModalId}`);
            closeAccountModal(modal);
          }
        },
        onError: () => {
          if (!callbacks) {
            return;
          }
          if (callbacks.onLoginFail) {
            callbacks.onLoginFail();
          }
        },
      },
    );
  }
};

const onModalClose = (event, callback) => {
  if (callback) {
    callback();
  }
};

const onModalButtonClick = (event) => {
  const {
    grecaptchaApi,
    isAuthenticated,
    loginUrl,
    myAccountUrl,
  } = window;
  if (isAuthenticated) {
    return;
  }
  event.preventDefault();
  // Only launch modal if score threshold is met.
  // Otherwise should redirect to login page
  // (w/ recaptcha challenge).
  const score = grecaptchaApi.currentScore;
  if (grecaptchaApi.displayChallenge(score)) {
    window.location = loginUrl;
  } else {
    launchLoginModal({ // eslint-disable-line no-use-before-define
      type: '',
      callbacks: {
        onLoginSuccess: (isNewAccount) => {
          if (isNewAccount) {
            window.location = `${myAccountUrl}?newaccount=true`;
          } else {
            window.location = myAccountUrl;
          }
        },
        onLoginFail: () => {},
      },
    });
  }
};

const onLogoutButtonClick = (event) => {
  event.preventDefault();
  logout({
    onSuccess: () => {
      clearAllSwatchbookData();
      window.location = window.loginUrl;
    },
  });
};

const addLogoutEventHandlers = () => {
  const logoutBtns = document.querySelectorAll('a[href="/logout"], a[href="/logout/"]');
  if (logoutBtns) {
    [].map.call(logoutBtns, btn => btn.addEventListener('click', onLogoutButtonClick));
  }
};

const removeModalEventHandlers = () => {
  const modalBtns = document.querySelectorAll('.acct-login-modal-btn');
  if (modalBtns) {
    [].map.call(modalBtns, btn => btn.removeEventListener('click', onModalButtonClick));
  }
};

const addModalEventHandlers = () => {
  const modalBtns = document.querySelectorAll('.acct-login-modal-btn');
  if (modalBtns) {
    [].map.call(modalBtns, btn => btn.addEventListener('click', onModalButtonClick));
  }
};

const checkLoginStatus = (callback) => {
  // console.log(`login.js, checkLoginStatus, isAuthenticated: ${window.isAuthenticated}`);
  const body = document.getElementsByTagName('body')[0];
  if (window.isAuthenticated) {
    body.classList.add('is-authenticated');
    removeModalEventHandlers();
    addLogoutEventHandlers();
    // Check to see if there are any swatches in localstorage
    const localStorageData = getAllOfType('swatch');
    if (localStorageData.length !== 0) {
      addSwatches(localStorageData, {
        onSuccess: () => {
          clearAllSwatchbookData();
          updateAccountIconStatus();
          if (callback) {
            callback();
          }
        },
        onError: () => {
          updateAccountIconStatus();
          if (callback) {
            callback();
          }
        },
      });
    } else {
      updateAccountIconStatus();
      if (callback) {
        callback();
      }
    }
  } else {
    body.classList.remove('is-authenticated');
    // Do not add unless recaptcha threshold score is met
    addModalEventHandlers();
    updateAccountIconStatus();
  }
};

const toggleCreateAccountForm = (isVisible) => {
  const modal = document.getElementById(loginModalId);
  if (isVisible) {
    modal.querySelector('.account-login-container').classList.add('hidden');
    modal.querySelector('.login-side-column').classList.add('hidden');
    modal.querySelector('.create-account-container').classList.remove('hidden');
    modal.querySelector('.create-account-side-column').classList.remove('hidden');
    if (modal.querySelectorAll('.login-message-wrapper').length !== 0) {
      modal.querySelector('.login-message-wrapper').classList.add('hidden');
    }
    modal.style.height = '600px';
  } else {
    modal.querySelector('.account-login-container').classList.remove('hidden');
    modal.querySelector('.login-side-column').classList.remove('hidden');
    modal.querySelector('.create-account-container').classList.add('hidden');
    modal.querySelector('.create-account-side-column').classList.add('hidden');
    modal.removeAttribute('style');
    if (modal.querySelectorAll('.login-message-wrapper').length !== 0) {
      modal.querySelector('.login-message-wrapper').classList.remove('hidden');
    }
  }
};

const launchLoginModal = (options) => {
  // Reset modal
  toggleCreateAccountForm();
  resetCreateAccountForm({
    form: document.querySelector('.modal-acct-create-form'),
  });
  const {
    type,
    callbacks,
  } = options;
  const modal = document.getElementById(loginModalId);
  if (type) {
    modal.classList.add('c-modal--loginCTA');
    modal.querySelector('.login-message-wrapper').classList.remove('hidden');
    let msg = '';
    switch (type) {
      case 'photo':
        msg = window.loginMessagePhoto;
        break;
      case 'location':
        msg = window.loginMessageDealer;
        break;
      case 'visualization':
        msg = window.loginMessageVisualization;
        break;
      default:
        break;
    }
    modal.querySelector('.login-message-wrapper p').innerHTML = msg;
  } else {
    modal.classList.remove('c-modal--loginCTA');
    modal.querySelector('.login-message-wrapper').classList.add('hidden');
    modal.querySelector('.login-message-wrapper p').innerHTML = '';
  }
  const overlay = document.querySelector('#modal-overlay');
  openAccountModal(modal);
  // Submit modal form
  const loginSubmitBtn = modal.querySelector('.acct-login-modal-form .o-form__submit');
  const modalCloseBtn = modal.querySelector('#close-btn');
  // Only run once
  if (initialLanuch) {
    initialLanuch = false;
    loginSubmitBtn.addEventListener('click', (event) => {
      onLoginSubmit(event, callbacks);
    });
    modalCloseBtn.addEventListener('click', (event) => {
      event.stopPropagation();
      onModalClose(event, callbacks.onLoginFail);
    });
    if (overlay) {
      overlay.addEventListener('click', event => onModalClose(event, callbacks.onLoginFail));
    }
    // Toggle create account form
    if (type === 'visualization' || type === 'photo' || type === 'location') {
      [].map.call(document.querySelectorAll('.create-account-btn, .acct-login-modal-form .form-error-message a'), btn => btn.addEventListener('click', (event) => {
        setCreateAccountFocus({
          form: document.querySelector('.modal-acct-create-form'),
        });
        event.preventDefault();
        addCreateAccountCallbacks({
          onLoginSuccess: () => {
            // Get opt-in status and dispatch event
            const optinIpt = document.getElementById('modal-offer-opt-in');
            const optin = optinIpt ? optinIpt.checked : false;
            dispatchSiteEvent(siteEventNames.ON_ACCOUNT_CREATED, { optin });
            callbacks.onLoginSuccess(true);
            closeAccountModal(modal);
          },
          onLoginFail: () => {
            callbacks.onLoginFail();
          },
        });
        toggleCreateAccountForm(true);
      }));
    }
  }
};

const submitForm = (data, callbacks) => {
  login(data, callbacks);
};

const init = () => {
  checkLoginStatus();
};

export {
  checkLoginStatus,
  init,
  launchLoginModal,
  submitForm,
};
/* eslint-enable no-console */
